/**
 * @file 主账号业务用量页面
 */
<template>
  <div class="p-business-usage">
    <div class="p-business-usage-search">
      <plv-condition-filter v-model="conditionFilter" @search="handleSearch">
        <plv-condition-filter-item label="账期">
          <el-date-picker
            v-model="conditionFilter.dateRange"
            value-format="timestamp"
            size="small"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :picker-options="{
              disabledDate: filterDisabledMonth,
              onPick: onMonthPicker
            }"
            :clearable="false"
            :default-time="['00:00:00', '23:59:59']"
          />
        </plv-condition-filter-item>
        <plv-condition-filter-item
          prop="productItem"
          label="产品分类"
        >
          <plv-cascader
            v-model="conditionFilter.billItem"
            :options="productOptions"
            placeholder="请选择"
          />
        </plv-condition-filter-item>

        <plv-condition-filter-item
          prop="email"
          label="分账号邮箱"
          placeholder="请输入分账号邮箱"
          type="input"
        />

        <plv-condition-filter-item type="search" />
      </plv-condition-filter>
    </div>
    <div class="p-business-usage-export">
      <plv-button @click="handleExportFile">导出数据</plv-button>
    </div>
    <div class="p-business-usage-table">
      <plv-table v-loading="loading" :data-source.sync="dataSource" @pageDataChange="handlePageChange">
        <plv-table-column
          v-for="item of tableItems"
          :key="item.prop"
          :title="item.title"
          :prop="item.prop"
        />
      </plv-table>
    </div>
  </div>
</template>

<script>
import billMixin from '@/mixins/bill';
import { exportFile } from '@/utils/utils';
export default {
  mixins: [billMixin],
  data() {
    return {
      loading: false,
      tableItems: [
        { title: '账期', prop: 'accountPeriod' },
        { title: '分账号邮箱', prop: 'email' },
        { title: '备注', prop: 'memo' },
        { title: '产品', prop: 'production' },
        { title: '计费项', prop: 'category' },
        { title: '用量', prop: 'itemConsumed' },
        { title: '用量单位', prop: 'itemConsumedUnit' },
        { title: '结算日期', prop: 'statAt' }
      ]
    };
  },

  created() {
    this.getBusinessUsage();
  },
  methods: {
    async getBusinessUsage() {
      const params = this.getSearchParams();
      try {
        this.loading = true;
        const res = await this.$store.dispatch('account/getAccountDosage', params);
        this.dataSource.contents = res.contents;
        this.dataSource.pageNumber = res.pageNumber;
        this.dataSource.pageSize = res.pageSize;
        this.dataSource.totalItems = res.totalItems;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.dataSource.pageNumber = 1;
      this.getBusinessUsage();
    },
    handlePageChange() {
      this.getBusinessUsage();
    },
    async handleExportFile() {
      const params = this.getSearchParams();
      const res = await this.$store.dispatch('account/exportDosageFile', params);
      res && exportFile(res);
    },
  }
};
</script>

<style lang="scss" scoped>
.p-business-usage {
  padding: 0 18px;
  .p-business-usage-export {
    margin-bottom: 20px;
  }
}
</style>
